export const GET_DELIVERED_ORDERS = 'get_delivered_orders';
export const UPDATE_DELIVERED_ORDERS = 'update_delivered_orders';